interface Props extends React.SVGProps<SVGSVGElement> {
    isCopied?: boolean;
}

function CopyIcon(props: Props) {
    const { isCopied, ...rest } = props;
    return !isCopied ? (
        <svg viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.87207 8.31641C6.87207 7.21184 7.7675 6.31641 8.87207 6.31641H14.5016C15.6061 6.31641 16.5016 7.21184 16.5016 8.31641V13.3281C16.5016 14.4327 15.6061 15.3281 14.5016 15.3281H8.87207C7.7675 15.3281 6.87207 14.4327 6.87207 13.3281V8.31641ZM14.5016 8.31641H8.87207V13.3281H14.5016V8.31641Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.02246 3.36719C3.02246 2.26262 3.91789 1.36719 5.02246 1.36719H10.3771C11.4817 1.36719 12.3771 2.26262 12.3771 3.36719V4.63574H10.3771V3.36719H5.02246V8.99737H5.67204V10.9974H5.02246C3.91789 10.9974 3.02246 10.1019 3.02246 8.99737V3.36719Z"
                fill="currentColor"
            />
        </svg>
    ) : (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default CopyIcon;
